<template>
    <div class="contact-overlay">
        <div class="contact-overlay--content-wrapper grid grid__base">
            <overlay-close-btn :facets="['small']"/>
            <div class="grid--container">
                <div class="contact-overlay--row grid--row">
                    <div class="contact-overlay--col grid--col">
                        <div class="contact-overlay--content" v-if="content">
                            <v-runtime-template :template="content"/>
                        </div>
                        <div class="contact-overlay--loader-wrapper" v-else>
                            <dat-loader/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapActions } from 'vuex';
    import Axios from 'util/service';
    import VRuntimeTemplate from 'v-runtime-template';
    import OverlayCloseBtn from 'framework/global-components/dyn/overlay-close-btn/overlay-close-btn';
    import DatLoader from 'framework/components/dat-loader/dat-loader';

    export default {
        components: {
            DatLoader,
            OverlayCloseBtn,
            VRuntimeTemplate,
        },

        props: {
            url: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                content: null,
            };
        },

        methods: {
            ...mapActions('scroll', ['disableScroll']),
        },

        beforeDestroy() {
            this.disableScroll({ isLocked: false });
        },

        mounted() {
            this.disableScroll({ isLocked: true });

            Axios.get(this.url)
                .then(({ data }) => {
                    this.content = data;
            });
        },
    };
</script>
